var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDisputeIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 18,
    viewBox: "0 0 20 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.38223 5.55556H10.6149C10.7329 5.55556 10.8267 5.65278 10.8232 5.77083L10.5628 12.5764C10.5593 12.6875 10.4656 12.7778 10.3545 12.7778H9.64265C9.53154 12.7778 9.43779 12.691 9.43432 12.5764L9.1739 5.77083C9.17043 5.65278 9.26418 5.55556 9.38223 5.55556ZM10.0003 13.4722C9.46209 13.4722 9.02807 13.9063 9.02807 14.4444C9.02807 14.9826 9.46209 15.4167 10.0003 15.4167C10.5385 15.4167 10.9725 14.9826 10.9725 14.4444C10.9725 13.9063 10.5385 13.4722 10.0003 13.4722ZM19.7746 15.2778L11.4447 0.833333C10.8058 -0.277778 9.1982 -0.277778 8.55584 0.833333L0.225981 15.2778C-0.412908 16.3854 0.385703 17.7778 1.67043 17.7778H18.3336C19.6114 17.7778 20.417 16.3889 19.7746 15.2778ZM18.3336 16.6667H1.66695C1.23987 16.6667 0.972509 16.2049 1.18431 15.8333L9.51765 1.38889C9.72945 1.02083 10.2676 1.01736 10.4795 1.38889L18.8128 15.8333C19.0281 16.2014 18.7607 16.6667 18.3336 16.6667Z",
    fill: "#FF4D55"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 17.7778,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDisputeIcon);
export default __webpack_public_path__ + "static/media/dispute_icon.f7e338cc197e80c404cd2bb2e487367b.svg";
export { ForwardRef as ReactComponent };